import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ActivePageService } from '@services/active-page/active-page.service';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { ToastService } from '@services/common/toast.service';
import { QuestionnaireConfigState } from '@state/questionnaire.config.state';
import { QuestionnaireState } from '@state/questionnaire.state';
import { QuestionCriteriaDto } from 'app/@types/dto/question-criteria-dto.model';
import { SectionDto } from 'app/@types/dto/section-dto.model';
import { PageDto } from 'app/@types/dto/page-dto.model';
import { QuestionDto } from 'app/@types/dto/question-dto.model';
import { QuestionInstanceDto } from 'app/@types/dto/question-instance-dto.model';
import { QuestionnaireConfig } from 'app/@types/dto/questionnaire-config.model';
import { QuestionnaireDto } from 'app/@types/dto/questionnaire-dto.model';
import { combineLatest, Observable, Subject, takeUntil } from 'rxjs';
import { OrganizationState } from '@state/organization.state';
import { OrganizationEntityDto } from 'app/@types/dto/organization-entity-dto.model';

@Component({
    selector: 'app-mobility-page',
    templateUrl: './mobility-page.component.html',
    styleUrls: ['./mobility-page.component.scss'],
})
export class MobilityPageComponent implements OnInit, OnDestroy {
    @Select(QuestionnaireConfigState.getStaticConfig) config$: Observable<QuestionnaireConfig>;
    @Select(QuestionnaireState.getQuestionInstances) questionInstancePerQuestionId$: Observable<
        Map<string, QuestionInstanceDto[]>
    >;
    @Select(QuestionnaireState.getExternalUpdate) externalUpdates$: Observable<Set<string>>;
    @Select(QuestionnaireState.getQuestionnaire) questionnaire$: Observable<QuestionnaireDto>;
    @Select(OrganizationState.getEntities) entities$: Observable<OrganizationEntityDto[]>;

    private ngUnsubscribe = new Subject<void>();
    public activePage: PageDto;
    public config: QuestionnaireConfig;
    private questionInstancePerQuestionCode: Map<string, QuestionInstanceDto[]>;
    private questionPerQuestionCode: Map<string, QuestionDto> = new Map();
    private hasBeenFTEwarned: boolean = false;
    public externalUpdates: Set<string> = new Set();
    public currentEntityFte: number;
    public isLoaded: boolean = false;
    public questionnaire: QuestionnaireDto;
    public activeSubSection: string;

    //Constructor
    constructor(
        private activePageService: ActivePageService,
        public translateService: CustomTranslateService,
        private store: Store,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        combineLatest([
            this.activePageService.getActivePage(),
            this.config$,
            this.questionInstancePerQuestionId$,
            this.questionnaire$,
            this.entities$,
        ])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(([page, config, questionInstancePerQuestionCode, questionnaire, entities]) => {
                if (page && config && questionInstancePerQuestionCode && questionnaire) {
                    this.activePage = page;
                    this.config = config;
                    this.questionInstancePerQuestionCode = questionInstancePerQuestionCode;
                    this.questionnaire = questionnaire;
                    this.currentEntityFte =
                        entities.find((e) => e.id === this.questionnaire.entityId)?.fulltimeEqCount ?? 0;
                }
            });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
    }
}
